import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import WiFi from '../../../assets/WiFi.svg';
import './PublicWifi.scss';

interface Props {
  rtl: boolean;
}

function PublicWifi(props: Props) {
  const { t } = useTranslation();
  const { rtl } = props;

  const floatDirection = rtl ? 'PW-right' : 'PW-left'
  return (
    <div className={`PublicWifi__Container ${floatDirection}`}>
      <img src={WiFi} alt="" />
      <Typography rtl={rtl} className='PW__title'>{t("Public_Wifi_Hotspot_Msg")}</Typography>
    </div>
  )
}

export default PublicWifi